<script setup lang="ts">
import { HeaderNav } from '../navigation';

const { color = 'white' } = defineProps<IProps>();
const MrbilitIcon = defineAsyncComponent(() => import('./MrbilitIcon.vue'));
const AirplaneTicketIcon = defineAsyncComponent(
    () => import('./AirplaneTicketIcon.vue')
);

interface IProps {
    disableSwitchAccount?: boolean;
    mainAccountOnly?: boolean;
    color?: 'white' | 'blue';
    compact?: boolean;
}
const { isAirplaneTicket } = useWhiteLabel();
const siteMenuColor = computed(() =>
    color === 'white' ? 'white' : 'var(--blue-400)'
);
</script>

<template>
    <nav class="header-wrapper container">
        <AirplaneTicketIcon
            v-if="isAirplaneTicket"
            class="mrbilit-icon-header"
            :color
        />
        <MrbilitIcon v-else class="mrbilit-icon-header" :color />
        <HeaderNav
            :color="siteMenuColor"
            :compact
            :disable-switch-account
            :main-account-only
        />
    </nav>
</template>

<style scoped lang="scss">
.header-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: auto;
    position: relative;
    z-index: 100000;

    @media (max-width: 1060px) {
        :deep() {
            .title {
                font-size: 12px !important;
            }

            .body {
                padding-inline: 0 !important;
            }
        }
    }
}
</style>
